module.exports = "https://trybtryb-legacy.web.app/img/tiktok_grey.373c5f7e.svg";